<template>
  <el-row>
    <el-col v-loading="isLoading">
      <template v-for="(team, index) in session.teams">
        <el-row :key="`r_${team.id}`">
          <el-col :span="20">
            {{ team.description }}
          </el-col>

          <el-col
            :span="4"
            class="text-right"
          >
            <el-radio
              v-model="selected"
              :label="team.id"
              class="mr-n3"
            >
              &nbsp;
            </el-radio>
          </el-col>
        </el-row>

        <el-divider
          v-if="index % 2 === 0"
          :key="`d_${team.id}`"
        />
      </template>
    </el-col>
  </el-row>
</template>

<script>
import { CREATED, UPDATED } from '@/plugins/sdk/Events'

export default {
  props: {
    value: {
      type: String,
      required: false,
      default: undefined
    }
  },
  data () {
    return {
      isLoading: true,
      session: new this.$sdk.session(),
      selected: undefined
    }
  },
  watch: {
    selected (value) {
      this.$emit('input', value)
    }
  },
  mounted () {
    this.loadSession()

    this
      .$sdk
      .session
      .on([CREATED, UPDATED], this.loadSession, this)
  },
  methods: {
    async loadSession () {
      this.isLoading = true
      this.session = await this.$session.instance
      this.selected = this.session.team.id
      this.isLoading = false
    }
  }
}
</script>
